import { useHistory } from 'react-router';

import { supportsNySakConfig } from '../api';
import { SakKilde } from '../classes';
import type { NySakConfigRequest } from '../classes';
import { SakRoutes } from '../config';
import { openExternalUrl } from '../helpers/SakHelpers';
import { useGetNySakConfigQuery } from '../rtkApi';

/**
 * Hvor «Ny sak» skal gå: til Dalux for bygg/kunder som er satt opp for det i Saks API,
 * ellers til dagens skjema. Uten kunde eller bygg (f.eks. uinnlogget) brukes alltid dagens skjema.
 * Mens oppsettet lastes er isLoading true, og «Ny sak» skal være deaktivert.
 */
export const useNySak = ({ kundeNummer, byggNummer }: NySakConfigRequest) => {
    const history = useHistory();
    const skip = !supportsNySakConfig || (!kundeNummer && !byggNummer);

    const { data, isFetching } = useGetNySakConfigQuery(
        { kundeNummer, byggNummer },
        { skip },
    );

    const daluxUrl =
        !skip && data?.kilde === SakKilde.Dalux ? data.url : undefined;

    const isLoading = !skip && isFetching;

    const goToNySak = (state?: unknown) => {
        if (isLoading) {
            return;
        }

        if (daluxUrl) {
            openExternalUrl(daluxUrl);
            return;
        }

        history.push(SakRoutes.add(), state);
    };

    return {
        nySakHref: daluxUrl || SakRoutes.add(),
        isDalux: !!daluxUrl,
        isLoading,
        goToNySak,
    };
};
